import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const TableData = ({ data }) => {
    return (
        <table style={{ textAlign: 'left', display: 'block', maxHeight: '20vh', overflowY:  'scroll' }}>
            <tr>
                <th style={{ width: '50px' }}>Ref</th>
                <th>Descripcion</th>
                <th style={{ textAlign: 'center' }}>Marca</th>
                <th style={{ textAlign: 'center' }}>Modelo</th>
                <th style={{ textAlign: 'center' }}>Cantidad</th>
            </tr>
            {data.map((val, key) => {
                return (
                    <tr key={key}>
                        <th>{val.reference}</th>
                        <th>{val.description}</th>
                        <th style={{ textAlign: 'center', width: '100px' }}>{val.brand}</th>
                        <th style={{ textAlign: 'center', width: '100px' }}>{val.model}</th>
                        <th style={{ textAlign: 'center', width: '100px' }}>{val.count}</th>
                    </tr>
                )
            })}
        </table>
    )
}

const TableError = ({ data }) => {
    return (
        <table style={{ textAlign: 'left', display: 'block', maxHeight: '10vh', overflowY:  'scroll', width: '100%' }}>
            <tr>
                <th style={{ width: '50px' }}>Ref</th>
                <th style={{ width: '100%', textAlign: 'center' }}>Error</th>
            </tr>
            {data.map((val, key) => {
                return (
                    <tr key={key}>
                        <th>{val.reference}</th>
                        <th style={{ textAlign: 'center' }}>{val.error}</th>
                    </tr>
                )
            })}
        </table>
    )
}

const DialogImportStock = ({ open, dataAdded, dataUpdated, dataError, handlePrint, handleClose }) => {
    dataAdded = dataAdded || []
    dataUpdated = dataUpdated || []
    dataError = dataError || []
    const dataPrint = [...dataAdded, ...dataUpdated]

    const anyAdded = dataAdded.length > 0
    const anyUpdated = dataUpdated.length > 0
    const anyError = dataError.length > 0

    return (
        <Dialog maxWidth='xl' open={open}>
            <DialogTitle>Importacion de datos</DialogTitle>
            <DialogContent dividers>
                {anyAdded && <DialogContentText>Se han importado {dataAdded.length} filas.</DialogContentText> }
                {anyAdded && <DialogContentText>
                    <TableData data={dataAdded} />
                </DialogContentText> }
                {anyUpdated && <DialogContentText>Se han actualizado {dataUpdated.length} filas.</DialogContentText> }
                {anyUpdated && <DialogContentText>
                    <TableData data={dataUpdated} />
                </DialogContentText> }
                {anyError && <DialogContentText>Han fallado {dataError.length} filas.</DialogContentText> }
                {anyError && <DialogContentText>
                    <TableError data={dataError} />
                </DialogContentText> }
                <DialogContentText>¿Quieres imprimir?</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cerrar</Button>
                <Button onClick={() => handlePrint(dataPrint)} color='primary'>Aceptar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogImportStock